export interface CruiseHighlight {
  id: string,
  label: string,
  value: string,
  shape?: CruiseHighlightShape,
  backgroundColor: string,
  borderColor: string,
  textColor: string,
}

export enum CruiseHighlightShape {
  Inclined = 'inclined',
  Rounded = 'rounded',
}